import { users } from '../api/api';

function formatApiMessage(message, fallback) {
  if (Array.isArray(message)) return message[0] || fallback;
  return message || fallback;
}

export const registerUser = async (userData) => {
  const registrationType = userData.registration_type || 'individual';

  const payload = {
    name: (userData.name ?? '').trim(),
    email: (userData.email ?? '').toString().toLowerCase().trim(),
    password: userData.password,
    phone: (userData.phone ?? '').trim(),
    registration_type: registrationType
  };

  if (registrationType === 'individual') {
    payload.nida = (userData.nida ?? '').trim();
  } else if (registrationType === 'hub') {
    payload.hub = {
      name: (userData.hub?.name ?? '').trim(),
      title: (userData.hub?.title ?? '').trim(),
      location: (userData.hub?.location ?? '').trim(),
      phone: (userData.hub?.phone ?? '').trim(),
      email: (userData.hub?.email ?? '').toString().toLowerCase().trim()
    };
  }

  try {
    const { data } = await users.register(payload);
    const ok = (data?.status ?? '').toString().toUpperCase() === 'OK';
    const message = formatApiMessage(data?.errorMessage, ok ? 'User registered successfully' : 'Registration failed');

    if (ok) {
      return { success: true, message, data: data?.returnData ?? payload };
    }

    return { success: false, message, data: null };
  } catch (err) {
    const message = formatApiMessage(
      err.response?.data?.errorMessage,
      err.message || 'Registration failed'
    );
    return { success: false, message, data: null };
  }
};
